import React from "react"
import "./PostBody.scss"
import parse from "html-react-parser"

const PostBody = ({ data, className }) => {
  return <div className={className}>{data.body && parse(data.body)}</div>
}

export default PostBody
